import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { map } from 'rxjs/operators';
import { AccessSolicitudExViewModel } from '../../_importacion/solicitudes/types/enum';
import { BASE_URL_SERVICE } from 'src/app/app.module';

export function AccessSolicitudExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', id);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessSolicitud/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessSolicitanteExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', route.parent!.paramMap.get('id')!);
            params = params.append('idSolicitante', id);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessSolicitante/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessProductoExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idProd = route.paramMap.get('idprod');

        if (idProd) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', route.parent!.paramMap.get('id')!);
            params = params.append('idProductoEx', idProd);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessProducto/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessEmbalajeExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idEmb = route.paramMap.get('idemb');

        if (idEmb) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', route.parent!.paramMap.get('id')!);
            params = params.append('idEmbalajeEx', idEmb);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessEmbalaje/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessDocumentosExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idDocumento = route.paramMap.get('idDocumento');

        if (idDocumento) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', route.parent!.paramMap.get('id')!);
            params = params.append('idDocumento', idDocumento);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessDocumento/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            return false;
        }
    };
}

export function AccessSeguimientoExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idSeguimientoEx = route.paramMap.get('idSeguimiento');

        if (idSeguimientoEx) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudEx', route.parent!.paramMap.get('id')!);
            params = params.append('idSeguimientoEx', idSeguimientoEx);

            return http.get<boolean>(baseUrl + 'api/exportacion/main/accessSeguimiento/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function ActionEstadoExGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        let idSolicitudEx = route.paramMap.get('id');
        if (!idSolicitudEx) {
            console.error('You are not allowed to see this page');
            return false;
            //route.parent!.paramMap.get('idSolicitudEx')!;
        }

        const http = inject(HttpClient);
        const baseUrl = inject(BASE_URL_SERVICE);
        const router = inject(Router);
        const authService = inject(AuthService);
        let user = authService.getLoggedInUser()!;

        let params = new HttpParams();
        params = params.append('idSolicitudEx', idSolicitudEx!);

        return http.get<AccessSolicitudExViewModel>(baseUrl + 'api/exportacion/main/idEstadoTipoSolicitudEx/', { params: params }).pipe(
            map(res => {
                if (user.getAction(route.data.actionCode, res.IdEstadoSolicitudEx, res.IdTipoSolicitudEx).Visible) {
                    return true;
                } else {
                    console.error('You are not allowed to see this page');
                    router.navigate(['/']);
                    return false;
                }
            }),
        );

        //@adua 29/07/2020 descomentar lo de arriba, para que funcione cuando este Export mas maduro
        // return true;
    };
}
